import { isSalesGatedLocation } from './locations';

const ROUTE_NAME_TO_FEATURE_MAP = {
	resumes: 'resume_upload',
	'resumes.preview': 'resume_upload',
	'resume-tool': 'resume_upload',
	'resumes.edit': 'resume_upload',
	'cover-letters.index': 'cover_letter',
	'cover-letters.edit': 'cover_letter',
	'job-tracker': 'auto_apply_v2',
	'job-tracker-data-management': 'auto_apply_v2',
	'interview-ai': 'interview_ai',
	'interview-ai-interviews': 'interview_ai',
	'interview-ai-create': 'interview_ai',
	'interview-ai-interview': 'interview_ai',
	'interview-ai-complete': 'interview_ai',
	'networking-tool': 'network_tool',
	'networking-tool-favorites': 'network_tool',
	settings: 'settings',
};

const FEATURE_EXCEED_TITLE_MAP = {
	resume_upload: 'Upload unlimited resumes like top performers',
	bullet_generation_tool: 'Generate bullet points that get offers',
	cover_letter: 'Write cover letters that get interviews',
	network_tool: 'Network like users who get hired',
	interview_ai: 'Practice for the interviews that matter',
	interview: 'Practice for the interviews that matter',
	resume_scorer: 'See what\'s holding your resume back',
	job_tracker: 'Join users who land 2x more interviews ',
	find_email: 'Send emails that land interviews',
	cold_email: 'Send emails that land interviews',
	learning_hub: 'Start your journey to getting hired',
	auto_apply_v2: 'Apply to more jobs with AutoApply'
};

const FEATURE_EXCEED_MESSAGE_MAP = {
	resume_upload: '<p>Users who get hired have <span class="font-bold">71% higher resume scores.</span><br/> Get your detailed breakdown and join them!</p>',
	bullet_generation_tool: '<p>Users who land a job generate <span class="font-bold">3x more bullet points.</span><br/> Create unlimited professional bullet points now!</p>',
	cover_letter: '<p>Users who get hired generate <span class="font-bold">3x more cover letters.</span><br/> Create unlimited tailored cover letters!</p>',
	network_tool: '<p>Users who get hired send <span class="font-bold">5x more networking messages.</span><br/><span class="font-bold">82% focus on requesting interviews.</span> Join them now!</p>',
	interview_ai: '<p>Users who got hired land <span class="font-bold">2x more interviews</span> and convert <span class="font-bold">51% to offers.</span><br/> Get unlimited interview prep.</p>',
	interview: '<p>Users who got hired land <span class="font-bold">2x more interviews</span> and convert <span class="font-bold">51% to offers.</span><br/> Get unlimited interview prep.</p>',
	resume_scorer: '<p>Users who get hired have <span class="font-bold">2x higher resume scores.</span><br/> Get your detailed breakdown and join them!</p>',
	job_tracker: '<p>Users who get hired apply to <span class="font-bold">3x more jobs</span> and get <span class="font-bold">2x more interviews.</span><br/> Upgrade to their toolkit.</p>',
	learning_hub: '<p>Users who get hired apply to <span class="font-bold">3x more jobs</span> and get <span class="font-bold">2x more interviews.</span><br/> Get the complete toolkit that works.</p>',
	find_email: '<p>Users who get hired send 5x more networking messages.<br/> 82% focus on requesting interviews.</p>',
	cold_email: '<p>Users who get hired send <span class="font-bold">5x more networking messages.</span><br/><span class="font-bold">82% focus on requesting interviews.</span> Join them now!</p>',
	auto_apply_v2: '<p>Users who get hired apply to <span class="font-bold">3x more jobs.</span><br/> Upgrade for unlimited AutoApply uses!</p>',
};

/**
 * Whether the coaching call card should render within the plan comparison.
 * It is shown only on the settings page — never inside the premium plans modal,
 * which always passes `exceedLimit` — and only for users in a sales-gated location.
 *
 * @param {{ routeName: ?string, exceedLimit: boolean, user: ?object }} context
 * @returns {boolean}
 */
const shouldShowCoachingCard = ({ routeName, exceedLimit, user }) =>
	routeName === 'settings' && !exceedLimit && isSalesGatedLocation(user);

export {
	FEATURE_EXCEED_MESSAGE_MAP,
	FEATURE_EXCEED_TITLE_MAP,
	ROUTE_NAME_TO_FEATURE_MAP,
	shouldShowCoachingCard,
};
